import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoGogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.649 10.074c.172 0 .305.115.344.287.038.171-.077.324-.23.381-1.374.458-2.328 1.451-2.538 2.634-.21 1.184.343 2.425 1.47 3.34.133.096.152.287.076.44-.076.153-.267.21-.42.153-1.336-.516-2.71-.382-3.627.4-.935.764-1.317 2.081-1.03 3.494.019.171-.077.343-.23.4-.152.058-.343 0-.42-.152-.706-1.26-1.851-2.024-3.053-2.024-1.222 0-2.348.764-3.055 2.024-.076.152-.267.21-.42.152a.342.342 0 0 1-.229-.4c.287-1.413-.114-2.71-1.03-3.494-.917-.782-2.272-.916-3.627-.4-.153.057-.344 0-.42-.153-.095-.153-.057-.325.076-.44 1.126-.896 1.68-2.156 1.47-3.34-.19-1.183-1.145-2.176-2.52-2.634a.328.328 0 0 1-.229-.381c.02-.172.172-.287.344-.287 1.45.02 2.672-.572 3.283-1.622.61-1.05.516-2.405-.229-3.646-.076-.134-.057-.325.076-.42a.348.348 0 0 1 .459 0c1.088.954 2.424 1.279 3.55.859 1.145-.42 1.947-1.527 2.176-2.959.019-.152.172-.286.343-.286.172 0 .306.134.344.286.21 1.432 1.03 2.539 2.157 2.959 1.145.4 2.462.076 3.55-.878a.348.348 0 0 1 .459 0 .325.325 0 0 1 .076.439c-.744 1.24-.84 2.596-.23 3.646.612 1.05 1.833 1.66 3.284 1.622ZM7.18 12.403c-.19-2.787 1.928-5.211 4.734-5.402a5.087 5.087 0 0 1 5.421 4.734 5.125 5.125 0 0 1-.515 2.577c-1.146-.344-2.806-.573-4.639-.573-1.756 0-3.36.21-4.504.535a4.772 4.772 0 0 1-.497-1.871Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLogoGogo;
